const actionTypeList=[
    {id:0,name:"添加"},
    {id:1,name:"更新"},
    {id:2,name:"删除"},
    {id:3,name:"其他"},
]
export default actionTypeList